import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getOrder, updateOrder } from '../actions/OrderActions';
import { getPaymentTypes } from '../../paymentTypes/actions/PaymentTypeActions';

import { Pane, Heading, Button } from 'evergreen-ui';
import InfoBlock from '../../common/InfoBlock/InfoBlock';

import { Link } from 'react-router-dom';
import OrderForm from '../components/OrderForm';

import Configuration from '../Config';

const validation = Configuration.Validations.order;
const mapValidationErrors = Configuration.ErrorHandler.mapValidationErrors;

class EditOrder extends Component {
    constructor(props) {
        super(props);

        this.id = this.props.params.id;
    }
    componentDidMount() {
        this.props.dispatch(getOrder(this.id));
        this.props.dispatch(getPaymentTypes());
    }

    handleSave = (values) => {
        this.props.dispatch(updateOrder(this.props.order.id, values));
    }

    render() {
        return (
            <Pane padding={16} paddingTop={0}>
                <Pane display="flex">
                    <Pane>
                        <Link to="/orders">
                            <Button iconBefore="arrow-left" intent="none">
                                Inapoi la lista comenzi
                            </Button>
                        </Link>
                    </Pane>
                    
                    <Pane marginLeft={16}>
                        <Link to={`/orders/${this.id}`}>
                            <Button iconBefore="cross" intent="warning">
                                Anuleaza modificarile
                            </Button>
                        </Link>
                    </Pane>
                </Pane>

                <Pane flex={1} background="tint1" elevation={1} padding={16} marginTop={16}>
                    <Heading size={600}>
                        Modificare Comanda - <strong>#{this.props.order.orderNumber}</strong>
                    </Heading>
                </Pane>
                
                <Pane display="flex" justifyContent="space-between" flex={1} marginTop={16}>
                    <InfoBlock flex="1">
                        <OrderForm 
                            isEdit={true}
                            initialValues={this.props.order}
                            paymentTypes={this.props.paymentTypes}
                            validationSchema={validation}
                            onSave={this.handleSave}
                            errors={this.props.errors}/>
                    </InfoBlock>
                </Pane>
            </Pane>
        )
    }
}

function mapStateToProps(state) {
    return {
        errors: state.orders.errors.type === 'validation' ? mapValidationErrors(state.orders.errors.fields): [],
        order: state.orders.current,
        paymentTypes: state.paymentTypes.data
    }
}

export default connect(mapStateToProps)(EditOrder);